
export const menuItems = [
    {
      title: "Inicio",
      key: "/",
    },
    {
      title: "Proyectos",
      key: "/proyectos",
    },
    {
      title: "Cursos",
      key: "/cursos",
    },
    {
      title: "Experiencia",
      key: "/experiencia",
    },
    {
      title: "Contacto",
      key: "/contacto",
    },
  ];